import { render, staticRenderFns } from "./Circle8.vue?vue&type=template&id=63f8ce0d&scoped=true&"
import script from "./Circle8.vue?vue&type=script&lang=js&"
export * from "./Circle8.vue?vue&type=script&lang=js&"
import style0 from "./Circle8.vue?vue&type=style&index=0&id=63f8ce0d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63f8ce0d",
  null
  
)

export default component.exports